import { LitElement, html, svg } from 'lit';

export class IconCalendar24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Kalender</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.75 3.75H2.25a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5ZM.75 9.75h22.5M12 19v-5M13.5 19h-3M12 14l-1.5.5M6.75 5V1M17.25 5V1"></path></svg>`; }
}
if (!customElements.get('f-icon-calendar24', IconCalendar24)) {
  customElements.define('f-icon-calendar24', IconCalendar24);
}